Namespace 'Common.Sessions'

class Common.Sessions.SortDropdown extends Backbone.View
  template: JST['backbone/templates/common/dashboard/charts/sort_dropdown']
  className: 'sort-dropdown dropdown d-inline'

  events:
    'click li': '_updateSelectedOption'

  initialize: (@selectedOption) ->

  render: ->
    @$el.html @template
      options: @_options()
    @_setSelectedOption()
    @

  _options: ->
    SORT_TYPE = Common.Dashboard.Widget.SortType
    [
      {value: SORT_TYPE.ascAlphabetical, text: I18n.t('common.navbar.menu.sort.ascAlphabetical')},
      {value: SORT_TYPE.descAlphabetical, text: I18n.t('common.navbar.menu.sort.descAlphabetical')},
      {value: SORT_TYPE.descCount, text: I18n.t('common.navbar.menu.sort.descCount')},
      {value: SORT_TYPE.ascCount, text: I18n.t('common.navbar.menu.sort.ascCount')}
    ]

  _updateSelectedOption: (e) ->
    selectedOption = e.currentTarget.dataset.value
    return if @selectedOption == selectedOption
    @selectedOption = selectedOption
    @_setSelectedOption()
    @trigger('change', @selectedOption)

  _setSelectedOption: ->
    options = @$el.find('li')
    options.removeClass('disabled')
    options.find('.check').addClass('d-none')

    selectedOption = @$el.find("li[data-value='#{@selectedOption}']")
    selectedOption.addClass('disabled')
    selectedOption.find('.check').removeClass('d-none')

